<ion-header>
  <ion-toolbar>
    <ion-title>Escanear Código</ion-title>
    <ion-buttons slot="end">
      <ion-button color="dark" (click)="closeModal()">
          <ion-icon name="close"></ion-icon>
        </ion-button>
  </ion-buttons>
  </ion-toolbar>
</ion-header>


<ion-content>
  <ng-container *ngIf="hasPermission === undefined">
    <p class="colorBlack ion-text-center"><ion-spinner></ion-spinner> Accediendo a tu camara</p>
    <p class="colorBlack ion-text-center">Si tu dispositivo tiene camara debes aceptar los permisos</p>
  </ng-container>
  
  <ng-container *ngIf="hasPermission === false">
   <p>Has rechazado los permisos para acceder a la camara, no puedes escanear el código.</p>
  </ng-container>

  <zxing-scanner (scanSuccess)="onCodeResult($event)"
  (permissionResponse)="onHasPermission($event)"
  [formats]="formatsEnabled"
  ></zxing-scanner>

  
  <div class="ion-text-center" *ngIf="hasPermission == true">
    <h4 ckass="colorBlack"><b>Resultado: </b> {{ qrResultString }} <span *ngIf="!qrResultString">-----</span> </h4>
    <button class="z-depth-2 smallButton" (click)="saveResult()">GUARDAR</button>
  </div>
</ion-content>
